const esPagesToExclude = ['/docs/about-zerobounce/data-processing-agreement-in', '/chris', '/ciprian', '/austin', '/bhavna'];
const noIndexMetaPagesExcluded = [
  '/zerobounce-vs-neverbounce.html',
  '/zerobounce-vs-neverbounce/',
  '/zerobounce-vs-snov/',
  '/zerobounce-vs-kickbox.html',
  '/zerobounce-vs-kickbox/',
  '/zerobounce-vs-millionverifier.html',
  '/zerobounce-vs-millionverifier/',
  '/zerobounce-vs-mailtester.html',
  '/zerobounce-vs-mailtester/',
  'zerobounce-vs-briteverify.html',
  'zerobounce-vs-briteverify/',
  '/zerobounce-vs-verifalia.html',
  '/zerobounce-vs-verifalia/',
  '/zerobounce-vs-bounceless.html',
  '/zerobounce-vs-bounceless/',
  '/zerobounce-vs-emailable/',
  '/zerobounce-vs-xverify/',
  '/zerobounce-vs-hunter/',
  '/zerobounce-vs-mailreach-co/',
  '/zerobounce-vs-lemwarm/',
  '/zerobounce-vs-instantly-ai/',
  '/zerobounce-vs-warmy-io/',
  '/zerobounce-vs-warmup-inbox/',
];
const noIndexLandingPages = [
  '/email-validator/',
  '/email-validation-page/',
  '/email-validation-tools/',
  '/email-validity-checker/',
  '/email-verifier/',
  '/email-checker/',
  '/email-bounce/',
  '/email-verification-service/',
  '/email-validator-v2/',
  '/email-validation-page-v2/',
  '/email-validity-checker-v2/',
  '/email-verifier-v2/',
  '/email-checker-v2/',
  '/email-bounce-v2/',
  '/email-verification-service-v2/',
  '/chris/',
  '/bhavna/',
  '/austin/',
  '/ciprian/',
  '/rohit/',
  '/jack/',
  '/zerobounce-litmus-3p-webinar',
  '/holiday-checklist/',
  '/google-yahoo-webinar-promo/',
  '/email-cleaner/',
  '/email-scrubbing/',
  '/dmarc-monitor-page/',
  '/spam-traps-page/',
  '/zerobounce/',
  '/real-time-validation-demo/',
  '/email-deliverability-guide/',
  '/email-list-verification/',
  '/email-address-verification/',
  '/email-list-cleaner/',
  '/jon/',
  '/mirela/',
  '/email-marketing-heroes/',
  '/how-to-identify-spam-traps/',
  '/spam-trap-removal/',
  '/scrub-email-list/',
  '/best-email-verification-service/',
  '/validate-email-addresses/',
  '/email-hygiene-service/',
  '/validate-email-list/',
  '/remove-bounced-emails/',
  '/litmus-live/',
  '/conference/',
  '/email-warmup-service/',
  '/email-finder-tools/',
  '/validation-cart/',
  '/toolkits-cart/',
  '/meet/',
  '/GenZ-work-report/',
  '/services/email-validation-test',
  'email-validation-pricing-test',
];

module.exports.esPagesToExclude = esPagesToExclude;
module.exports.noIndexMetaPagesExcluded = noIndexMetaPagesExcluded;
module.exports.noIndexLandingPages = noIndexLandingPages;
